export const getAnonymousUserId = () => janeMixpanel.get_distinct_id();
